// Lightweight recent-sync activity log (Drive mode). Stored in
// localStorage per user so it survives reloads; capped so it can't grow
// unbounded. Purely informational — surfaced in Settings.

const KEY_PREFIX = 'plant_sync_history_';
const MAX_ENTRIES = 25;
export const SYNC_HISTORY_CHANGED_EVENT = 'plant-sync-history-changed';

function keyFor(userKey) {
  return `${KEY_PREFIX}${userKey || 'anon'}`;
}

function notifyChanged() {
  try {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(SYNC_HISTORY_CHANGED_EVENT));
    }
  } catch { /* no-op */ }
}

/**
 * Append events to the log. Each event: { op, name, status, at? }.
 * status ∈ 'synced' | 'conflict' | 'gaveup' | 'discarded'.
 */
export function recordSyncEvents(userKey, events) {
  if (!Array.isArray(events) || events.length === 0) return;
  try {
    const now = Date.now();
    const stamped = events.map((e) => ({ at: now, ...e }));
    const existing = getSyncHistory(userKey);
    const merged = [...stamped, ...existing].slice(0, MAX_ENTRIES);
    localStorage.setItem(keyFor(userKey), JSON.stringify(merged));
    notifyChanged();
  } catch { /* quota / private mode */ }
}

/** Read the log (newest first). */
export function getSyncHistory(userKey) {
  try {
    const raw = localStorage.getItem(keyFor(userKey));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** Remove the log entry stamped with an exact timestamp (used by Undo). */
export function removeSyncEventAt(userKey, at) {
  try {
    const existing = getSyncHistory(userKey);
    const filtered = existing.filter((e) => e.at !== at);
    localStorage.setItem(keyFor(userKey), JSON.stringify(filtered));
    notifyChanged();
    return true;
  } catch {
    return false;
  }
}

/** Wipe the log for a user. */
export function clearSyncHistory(userKey) {
  try {
    localStorage.removeItem(keyFor(userKey));
    notifyChanged();
    return true;
  } catch {
    return false;
  }
}
